<template>
  <div>
    <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
      <div class="uk-card-body">
        <div class="uk-overflow-auto">
          <table
            class="uk-table uk-table-middle uk-table-hover uk-table-divider"
            v-if="offers.length"
          >
            <thead>
              <tr>
                <th class="uk-table-expand">Fahrzeug</th>
                <th class="uk-table-shrink uk-text-right">Datum</th>
                <th style="width:85px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="offer in offers" :key="offer.id">
                <td>
                  {{ offer.name }}<br /><span class="uk-text-small">Nr.: {{ offer.carId }}</span>
                </td>
                <td class="uk-text-right uk-text-nowrap">{{ offer.formatedDate }}</td>
                <td class="uk-text-right">
                  <a
                    href="#"
                    class="uk-text-primary"
                    :uk-icon="'icon: download'"
                    @click.prevent="getPdf(offer)"
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!offers.length" class="uk-margin-remove uk-h4">
          Keine Angebote vorhanden!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Configuration from '@/configuration';
const baseURL = Configuration.value('apiBackend')
export default {
  props: {
    offers: {
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    getPdf(offer) {
      axios({
        url: `${baseURL}/offer/print/${offer.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${offer.filename}`)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
